var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_23181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4038 9.3754C16.7422 7.66408 15.5936 6.18412 14.1001 5.11845C12.6065 4.05278 10.8335 3.4481 9 3.37915C7.16655 3.4481 5.39347 4.05278 3.89993 5.11845C2.40639 6.18412 1.25785 7.66408 0.596255 9.3754C0.551574 9.49899 0.551574 9.63432 0.596255 9.7579C1.25785 11.4692 2.40639 12.9492 3.89993 14.0149C5.39347 15.0805 7.16655 15.6852 9 15.7542C10.8335 15.6852 12.6065 15.0805 14.1001 14.0149C15.5936 12.9492 16.7422 11.4692 17.4038 9.7579C17.4484 9.63432 17.4484 9.49899 17.4038 9.3754ZM9 14.6292C6.01875 14.6292 2.86875 12.4185 1.72688 9.56665C2.86875 6.71478 6.01875 4.50415 9 4.50415C11.9813 4.50415 15.1313 6.71478 16.2731 9.56665C15.1313 12.4185 11.9813 14.6292 9 14.6292Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.19165C8.33249 6.19165 7.67997 6.38959 7.12495 6.76044C6.56994 7.13129 6.13735 7.65839 5.88191 8.27509C5.62646 8.89179 5.55963 9.57039 5.68985 10.2251C5.82008 10.8798 6.14151 11.4811 6.61352 11.9531C7.08552 12.4251 7.68689 12.7466 8.34157 12.8768C8.99626 13.007 9.67486 12.9402 10.2916 12.6847C10.9083 12.4293 11.4354 11.9967 11.8062 11.4417C12.1771 10.8867 12.375 10.2342 12.375 9.56665C12.375 8.67154 12.0194 7.8131 11.3865 7.18017C10.7536 6.54723 9.89511 6.19165 9 6.19165ZM9 11.8167C8.55499 11.8167 8.11998 11.6847 7.74997 11.4375C7.37996 11.1902 7.09157 10.8388 6.92127 10.4277C6.75098 10.0166 6.70642 9.56415 6.79323 9.1277C6.88005 8.69124 7.09434 8.29033 7.40901 7.97566C7.72368 7.66099 8.12459 7.4467 8.56105 7.35988C8.99751 7.27307 9.4499 7.31762 9.86104 7.48792C10.2722 7.65822 10.6236 7.94661 10.8708 8.31662C11.118 8.68663 11.25 9.12164 11.25 9.56665C11.25 10.1634 11.0129 10.7357 10.591 11.1576C10.169 11.5796 9.59674 11.8167 9 11.8167Z",
    fill: "#ffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_23181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.56665)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eyeOpen.abdaaae5587b46f03cc2278ed978671f.svg";
export { ForwardRef as ReactComponent };